import { AsyncPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { ColorPickerModule } from 'ngx-color-picker';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbAlertModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import {
  FormValidationModule,
  LoaderModule,
  TabsModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { CanvasModule } from '@tablesready/canvas';
import { ButtonGroupControlModule } from '@tablesready/button-group-control';
import { CheckboxGroupModule } from '@tablesready/checkbox-group';
import { SectionsComponent } from './components/sections/sections/sections.component';
import { FloorplanBuilderComponent } from './floorplan-builder.component';
import { FloorplanModalComponent } from './modals';
import {
  AddObjectFormComponent,
  AddTableFormComponent,
  DeleteTableModalComponent,
  ObjectsComponent,
  TablesComponent,
} from './components';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { RouterLinkWithHref } from '@angular/router';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [
    DeleteTableModalComponent,
    TablesComponent,
    FloorplanModalComponent,
    FloorplanBuilderComponent,
    AddTableFormComponent,
    ObjectsComponent,
    AddObjectFormComponent,
    SectionsComponent,
  ],
  imports: [
    ColorPickerModule,
    TabsModule,
    CanvasModule,
    NgbAlertModule,
    NgIf,
    FormValidationModule,
    NgSelectModule,
    ButtonGroupControlModule,
    ReactiveFormsModule,
    FrontendIconsModule,
    NgClass,
    NgForOf,
    CheckboxGroupModule,
    FormsModule,
    UtilsModule,
    AsyncPipe,
    LoaderModule,
    NgbTooltipModule,
    FrontendDropdownModule,
    RouterLinkWithHref,
    IonicModule,
  ],
  exports: [
    TablesComponent,
    FloorplanBuilderComponent,
    AddTableFormComponent,
    ObjectsComponent,
    AddObjectFormComponent,
  ],
})
export class FloorplanBuilderModule {}
